import { withDependencies, named } from '@wix/thunderbolt-ioc'
import { SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { CustomElementComponent, IWixCustomElementComponent, WixCustomElementComponentSiteConfig } from './types'
import { name } from './symbols'
import { loadScriptTag } from '@wix/thunderbolt-commons'

type WixCustomElementComponentFactory = (siteConfig: any) => IWixCustomElementComponent

const wixCustomElementComponentFactory: WixCustomElementComponentFactory = (
	siteConfig: WixCustomElementComponentSiteConfig
): IWixCustomElementComponent => {
	const customElementsTagNameMap: Record<string, boolean> = {}
	const customElementsUrlMap: Record<string, boolean> = {}
	const generateWixCodeUrl = (url: string) => {
		const queryParams = siteConfig.wixCodeUrl.queryParams ? `&${siteConfig.wixCodeUrl.queryParams}` : ''
		const wixCodeUrl = siteConfig.wixCodeUrl.url + url.replace('public/', '')
		return `${wixCodeUrl}?no-umd=true${queryParams}`
	}
	return {
		shouldLoadExternalScripts() {
			return siteConfig.shouldLoadExternalScripts
		},
		// if tag-name or script url already exist in map we do not load the
		async addCustomElement(customElement: CustomElementComponent) {
			if (customElementsTagNameMap[customElement.tagName] || customElementsUrlMap[customElement.url]) {
				return false
			} else {
				const url: string = customElement.hostedInCorvid
					? generateWixCodeUrl(customElement.url)
					: customElement.url
				await loadScriptTag(url)
				customElementsTagNameMap[customElement.tagName] = true
				customElementsUrlMap[url] = true
				return true
			}
		},
	}
}

export const WixCustomElementComponentAPI = withDependencies(
	[named(SiteFeatureConfigSymbol, name)],
	wixCustomElementComponentFactory
)
